"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItemHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CurrencyFormat = _interopRequireDefault(require("../../../CurrencyFormat"));
// Components:
// Icons:
var GiftIcon = function GiftIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "gift_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12",
    fill: "transparent"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__a)",
    d: "M3.5 22h-1v1h1v-1zm18 0v1h1v-1h-1zm-19-10v10h2V12h-2zm1 11h18v-2h-18v2zm19-1V12h-2v10h2z"
  }), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "gift_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778",
    fill: "transparent"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__b)",
    d: "M2.5 12h-1v1h1v-1zm0-5V6h-1v1h1zm20 0h1V6h-1v1zm0 5v1h1v-1h-1zm-12.222-1H2.5v2h7.779v-2zM3.5 12V7h-2v5h2zm-1-4h20V6h-20v2zm19-1v5h2V7h-2zm1 4h-7.778v2H22.5v-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-bow",
    stroke: "#17181A",
    fill: "transparent",
    d: "M14.5 8v14m-4-14v14m1.732-15.171c.093.26.16.486.206.668-1.175.025-2.688-.087-3.963-.483C6.958 6.54 6 5.752 6 4.523c0-.692.195-1.167.465-1.48.272-.313.657-.504 1.114-.562.929-.119 2.11.326 2.916 1.332.95 1.185 1.462 2.253 1.737 3.016zm.536 0c-.093.26-.16.486-.206.668 1.175.025 2.688-.087 3.963-.483C18.042 6.54 19 5.752 19 4.523c0-.692-.195-1.167-.465-1.48-.272-.313-.657-.504-1.114-.562-.928-.119-2.11.326-2.915 1.332-.95 1.185-1.463 2.253-1.738 3.016z"
  }));
};
GiftIcon.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
};
var FilterItemHeader = exports.FilterItemHeader = function FilterItemHeader(props) {
  var hasTours = props.hasTours,
    name = props.name,
    minPrice = props.minPrice;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  return /*#__PURE__*/_react["default"].createElement(StyledCheckboxTop, null, /*#__PURE__*/_react["default"].createElement(StyledCheckboxName, {
    disabled: !hasTours
  }, name), hasTours && /*#__PURE__*/_react["default"].createElement(StyledCheckboxPrice, null, t('hotel.filters.price'), "\xA0", /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: minPrice,
    currencyCode: code
  })));
};
var StyledCheckboxTop = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxTop",
  componentId: "sc-15mhw2t-0"
})(["display:flex;flex-direction:row;font-size:14px;"]);
var StyledCheckboxName = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxName",
  componentId: "sc-15mhw2t-1"
})(["max-width:225px;line-height:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme,
    disabled = _ref.disabled;
  return disabled && theme.colors.greyLight;
});
var StyledCheckboxPrice = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxPrice",
  componentId: "sc-15mhw2t-2"
})(["margin-left:auto;padding-left:5px;display:flex;align-items:center;font-size:14px;font-style:normal;font-weight:500;"]);
var StyledGiftIcon = (0, _styledComponents["default"])(GiftIcon).withConfig({
  displayName: "FilterItemHeader__StyledGiftIcon",
  componentId: "sc-15mhw2t-3"
})(["width:16px;height:16px;margin-left:4px;margin-right:4px;.gift-icon__bow{stroke-width:1;}.gift-icon__body{fill:#f8e71c;}"]);